<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chap-title">YOUR EXTREME CROCHET TOOLKIT</h1>
<p class="intro">The standard crochet kit is what you’ll need for taking on extreme crochet, along with a few tweaks and some other essentials:</p>
<h4 class="subhead2">SCISSORS</h4>
<p class="noindent1">Always useful. Make sure one pair is heavy duty enough to cope with cutting tougher yarns and threads.</p>
<h4 class="subhead2">TAPESTRY/DARNING NEEDLE</h4>
<p class="noindent1">The ends of larger yarns can be woven back into your work with your fingers, but you’ll still need a sturdy tapestry or darning needle with a blunt end. Make sure you find one with a really big eye for threading through those chunky yarns.</p>
<h4 class="subhead2">STITCH MARKER</h4>
<p class="noindent1">Useful for marking stitches, often the first one of a row or round. A large-sized one will be most useful, but you can always use a piece of coloured thread.</p>
<h4 class="subhead2">ROW COUNTER</h4>
<p class="noindent1">Useful for counting your completed rows and rounds. Paper and pen work just fine, too.</p>
<h4 class="subhead2">SEWING NEEDLE AND THREADS</h4>
<p class="noindent1">Sharp-ended and strong enough to pierce sturdy materials.</p>
<h4 class="subhead2">TOY STUFFING/BEAN BAG PELLETS</h4>
<p class="noindent1">You’ll need these to stuff cushions and poufs. Each project will specify exactly what you’ll need.</p>
<h4 class="subhead2">BUTTONS, RIBBONS AND OTHER PRETTIES</h4>
<p class="noindent1">Most crafters I know have a rather large stash of these sorts of things. Useful for creating interesting detail on your finished item.</p>
<h4 class="subhead2">HOOKS</h4>
<p class="noindent1">These are the most important pieces in your kit (alongside the yarn, of course). The projects in this book use big hooks. And some <i>massive</i> hooks. Each project will specify the hook size needed, but for this book you’re going to need:</p>
<table>
<tbody><tr>
<th>mm</th>
<th>imperial</th>
<th>US</th>
</tr>
<tr>
<td>4.5mm</td>
<td>7</td>
<td>7</td>
</tr>
<tr>
<td>9mm</td>
<td>00</td>
<td>M/N-13</td>
</tr>
<tr>
<td>10mm</td>
<td>000</td>
<td>N/P-15</td>
</tr>
<tr>
<td>12mm</td>
<td>0000</td>
<td>P/Q-16</td>
</tr>
<tr>
<td>15mm</td>
<td> </td>
<td>Q/19</td>
</tr>
<tr>
<td>20mm</td>
<td> </td>
<td>S/36</td>
</tr>
<tr>
<td>25mm</td>
<td> </td>
<td>50</td>
</tr>
</tbody></table>
<p class="image-center"><img alt="" src="images/I1-F2.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toolkit.vue?73e56a94